export const FETCH_CNC_VOUCHER_SENT_REPORT = "FETCH_CNC_VOUCHER_SENT_REPORT";
export const FETCH_CNC_VOUCHER_SENT_REPORT_SUCCESS =
  "FETCH_CNC_VOUCHER_SENT_REPORT_SUCCESS";
export const FETCH_CNC_VOUCHER_SENT_REPORT_FAILURE =
  "FETCH_CNC_VOUCHER_SENT_REPORT_FAILURE";
export const RESET_CNC_VOUCHER_SENT_REPORT = "RESET_CNC_VOUCHER_SENT_REPORT";

export const RESEND_CNC_VOUCHER = "RESEND_CNC_VOUCHER";
export const RESEND_CNC_VOUCHER_SUCCESS = "RESEND_CNC_VOUCHER_SUCCESS";
export const RESEND_CNC_VOUCHER_FAILURE = "RESEND_CNC_VOUCHER_FAILURE";
